<div [ngClass]="'ui-chips ui-widget'" [ngStyle]="style" [class]="styleClass">
    <ul [ngClass]="{'ui-inputtext ui-state-default ui-corner-all':true,'ui-state-focus':focus,'ui-state-disabled':disabled, 'ui-custom-ul':osmanClass}" (click)="inputtext.focus()">
        <li #token *ngFor="let item of value; let i = index;" [ngClass]="{'ui-chips-token ui-state-highlight ui-corner-all':true,'ui-custom-chips':osmanClass}">
            <span *ngIf="!itemTemplate&&!disabled" class="ui-chips-token-icon fa fa-fw fa-close" (click)="removeItem($event,i)"></span>
            <fa-icon [icon]="iconClose" *ngIf="!itemTemplate&&!disabled&&!osmanClass" class="ui-chips-token-icon" fixedWidth="fixedWidth" (click)="removeItem($event,i)"></fa-icon>
            <span *ngIf="!itemTemplate" class="ui-chips-token-label">{{field ? resolveFieldData(item,field) : item}}</span>
        </li>
        <li [ngClass]="{'ui-chips-input-token':true,'ui-custom-chips-input':osmanClass}">
            <input #inputtext
                type="text"
                pInputText
                [attr.placeholder]="placeholder"
                [attr.tabindex]="tabindex"
                (keydown)="onKeydown($event)"
                (focus)="onInputFocus($event)"
                (blur)="onInputBlur($event)"
                [disabled]="disabled">
        </li>
    </ul>
</div>
